import Cookies from 'js-cookie';

import { sdk } from '@/services';

const IMPERSONATE_USER_ID_COOKIE = 'impersonatedUserId';

const COOKIES_SETTINGS = {
  domain: import.meta.env.VITE_COOKIE_DOMAIN,
  path: '/'
};

const UserService = sdk.getService('UserService');

export const useGetUserBeforeImpersonate = () => {
  const setUserIdByEmail = async (email: string): Promise<string | undefined> => {
    try {
      const user = await UserService.getUserByEmail(email);
      if (user?._id) {
        const userId = user?._id;
        Cookies.set(IMPERSONATE_USER_ID_COOKIE, userId, COOKIES_SETTINGS);
      }
      return user?._id;
    } catch {
      return undefined;
    }
  };

  const getUserId = (): string | undefined => {
    return Cookies.get(IMPERSONATE_USER_ID_COOKIE) || undefined;
  };

  const clearUserId = (): void => {
    Cookies.remove(IMPERSONATE_USER_ID_COOKIE, COOKIES_SETTINGS);
  };

  return {
    setUserIdByEmail,
    getUserId,
    clearUserId
  };
};
